/**
 * Build provenance, inlined at compile time by Vite's `define`
 * (see vite.config.ts). Values originate from deploy-compose.sh →
 * docker-compose build-args → Dockerfile ENV → process.env. For local
 * `vite build` / `vite dev` they default to 'dev' / ''.
 *
 * Surfaced in the UI by <VersionBadge>, paired with the backend's
 * /api/system/version, so an operator can confirm exactly which commit
 * each surface is running after a deploy.
 */

declare const __BUILD_SHA__: string;
declare const __BUILD_TIME__: string;
declare const __BUILD_BRANCH__: string;

export const BUILD_INFO: {
  sha: string;
  builtAt: string;
  branch: string;
} = {
  sha: typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'dev',
  builtAt: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '',
  branch: typeof __BUILD_BRANCH__ !== 'undefined' ? __BUILD_BRANCH__ : '',
};
